import { Link } from 'react-router-dom';
import { categories, topics } from '@/mocks/topics';

const CATEGORY_ICONS: Record<string, string> = {
  行业内幕: 'ri-eye-off-line',
  消费乱象: 'ri-alert-line',
  维权纠纷: 'ri-scales-3-line',
  争议事件: 'ri-question-line',
};

export default function CategoryGrid() {
  return (
    <section aria-labelledby="category-title" className="w-full">
      <div className="border-b border-background-300 pb-4">
        <p className="font-label text-xs uppercase tracking-[0.2em] text-primary-600">Categories</p>
        <h2 id="category-title" className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
          主题分类追踪
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
          按议题类型归档，方便你顺着感兴趣的方向查看相关盘点与后续动态。
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((cat, index) => {
          const count = topics.filter((t) => t.category === cat.key).length;
          return (
            <Link
              key={cat.key}
              to={`/topics?category=${encodeURIComponent(cat.key)}`}
              className="group flex flex-col rounded-lg border border-background-300 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg ${
                  index === 1
                    ? 'bg-accent-100 text-accent-800'
                    : index === 2
                    ? 'bg-secondary-100 text-secondary-800'
                    : 'bg-primary-100 text-primary-800'
                }`}
              >
                <i className={`${CATEGORY_ICONS[cat.key]} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {cat.key}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 flex items-center justify-between font-label text-xs text-foreground-500">
                <span>收录 {count} 篇</span>
                <span className="inline-flex items-center gap-1 text-primary-700 opacity-0 transition-opacity group-hover:opacity-100">
                  查看
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}